import { MouseEventHandler } from "react";
import StyledButton from "./styled-components/StyledButton";

interface BooleanButtonProps {
  label: string;
  selected: boolean;
  value: boolean;
  onClick: MouseEventHandler;
}

function BooleanButton({
  label,
  selected,
  value,
  onClick,
}: BooleanButtonProps) {
  return (
    <StyledButton value={Number(value)} selected={selected} onClick={onClick}>
      {label}
    </StyledButton>
  );
}

export default BooleanButton;
